import React from 'react'
import cn from 'classnames'
import styles from './search.module.scss'
import SearchBar from './SearchBar'
import FilterOptionsControl_ from '../filters/FilterOptionsControl'
const FilterOptionsControl = FilterOptionsControl_ as any
import FilterOptions from '../filters/FilterOptions'
import usePanelContext from 'refactor/hooks/usePanelContext'
import useGetUser from 'refactor/hooks/api/useGetUser'
import { resolveUser } from 'state/cache'
import { Filter } from 'components/filters/useStreamFilters'
import { Quest } from 'types/quests'

interface SearchProps {
    filter: Filter
    setIsRefreshing: (value: boolean) => void
    quest?: Quest | null
}

export default function Search({ filter, setIsRefreshing }: SearchProps) {
    const { panel } = usePanelContext()
    const panelId = panel.panelId
    const query = filter?.query
    const [showFilterOptions, setShowFilterOptions] = React.useState(false)
    const filterOptionsRef = React.useRef<HTMLDivElement>(null)

    const filterUserId = filter?.user
    const { user: filterUser } = useGetUser(filterUserId)
    const resolvedFilterUser = React.useMemo(
        () => resolveUser(filterUser, filterUserId),
        [filterUser, filterUserId],
    )

    React.useEffect(() => {
        if (showFilterOptions && filterOptionsRef.current) {
            const rect = filterOptionsRef.current.getBoundingClientRect()
            filterOptionsRef.current.style.setProperty('--top-offset', `${rect.top}px`)
        }
    }, [showFilterOptions])

    return (
        <div className={cn(styles.searchComp)}>
            <div className={styles.filterOptionsControlContainer}>
                <FilterOptionsControl
                    filter={filter}
                    panel={panel}
                    user={gon.currentUser}
                    filterUser={resolvedFilterUser}
                    nameStyles={cn(styles.filterName)}
                    contextStyles={cn(styles.filterControl)}
                    iconStyles={cn(styles.filterIcon)}
                    showFilterOptions={showFilterOptions}
                    setShowFilterOptions={setShowFilterOptions}
                    showName
                    showLogo
                    showPublic
                    enableFilterIconClick={true}
                    // Pass icon styles
                    initialStyles={styles.initialStyles}
                    publicIcon={styles.publicIcon}
                    treechatIcon={styles.treechatIcon}
                    hodlockerIcon={styles.hodlockerIcon}
                    twetchIcon={styles.twetchIcon}
                    notiIcon={styles.notiIcon}
                    fontIcon={styles.fontIcon}
                    privateIcon={styles.privateIcon}
                    linksIcon={styles.linksIcon}
                    historyIcon={styles.historyIcon}
                    peopleIcon={styles.peopleIcon}
                />
            </div>

            <div className={styles.searchBarContainer}>
                <SearchBar
                    key={Object(filter).keys?.join('_')}
                    filter={filter}
                    query={query}
                    panel={panel}
                    placeholder="Search channel..."
                />
            </div>

            {showFilterOptions && (
                <div className={styles.filterOptionsModalContainer} ref={filterOptionsRef}>
                    <FilterOptions
                        origin="search"
                        header={'Choose channel to search'}
                        filter={filter}
                        panelId={panelId}
                        panel={panel}
                        query={query}
                        close={() => setShowFilterOptions(false)}
                        show={['public', 'private', 'user', 'ordinals', 'clips', 'teams']}
                        contextStyles={styles.filterOptions}
                        setShowFilterOptions={setShowFilterOptions}
                        showNoti={false}
                        blur
                    />
                </div>
            )}
        </div>
    )
}
